import { ActionButtonsType as e } from "../shared/actions.enum.js";
function s(t, n) {
  const { t: r } = n;
  switch (t) {
    case e.PORTAL_LINK:
      return r("loginText");
    case e.LOYALTY_LINK:
      return r("loyaltyCard");
    case e.REWARDS_LINK:
      return r("vouchers");
    case e.ORDER_LINK:
      return r("shopLanding.selector.nowBtn");
    case e.PAY_LINK:
      return r("payLink");
    case e.ORDER_HISTORY:
      return r("userOrders.heading");
    case e.PROFILE:
      return r("userProfile.navigation.profile");
    case e.BOOKING:
      return r("shopLanding.book");
    case e.PAYMENT_METHODS:
      return r("paymentMethods");
    case e.STAMP_CARDS:
      return r("stampCards");
    case e.CASHBACK:
      return r("cashback");
    case e.CUSTOM_LINK:
    default:
      return "";
  }
}
export {
  s as getBtnActionText
};
//# sourceMappingURL=i18n-helpers.js.map
